import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import Header from '@pages/companies/header'
import ArrowBack from '@components/arrowBack'
import Loading from '@components/loading'
import {
  TitleContainer,
  Title,
  Subtitle,
  TitleArea,
  ButtonContainer,
  Button,
  Container,
  TableContainer,
} from './styles'
import NotificationModal from '@components/modal/notificationModal'
import SearchExamsModal from '@components/modal/searchExamsModal'
import LabExamsTable from './labExamsTable'
import {
  getLastImportedAt as getLastImportedAtAction,
  listImportedExams as listImportedExamsAction,
  searchNewExams as searchNewExamsAction,
} from '@actions/exam'
import { getDateStringFromUsableDateStr } from '@util/timeUtil'

const ExamsImport = ({
  lastImportedAt, getLastImportedAt, listImportedExams, searchNewExams
}) => {
  const [showSearchExamsModal, setShowSearchExamsModal] = useState(false)
  const [showDatePickerModal, setShowDatePickerModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [initialExamsCount, setInitialExamsCount] = useState(0)
  const [difference, setDifference] = useState(0)
  const navigate = useNavigate()

  const parsedDate = lastImportedAt
    ? getDateStringFromUsableDateStr(lastImportedAt)
    : null

  useEffect(() => {
    if (lastImportedAt == null) {
      getLastImportedAt()
    }
    listImportedExams({ page: 0 }, (count) => {
      setInitialExamsCount(count)
    })
  }, [])

  const goBack = () => {
    navigate(-1)
  }

  const handleSearch = (startDate, endDate) => {
    setLoading(true)
    searchNewExams(startDate, endDate, () => {
      listImportedExams({ page: 0 }, (count) => {
        const diff = count - initialExamsCount
        setDifference(Number.isNaN(diff) ? 0 : diff)
        setInitialExamsCount(count)
        setShowSearchExamsModal(true)
        getLastImportedAt()
        setLoading(false)
      })
    })
  }

  return (
    <Container>
      <Header />
      <TitleContainer>
        <ArrowBack onClick={goBack} />
        <TitleArea>
          <Title style={{ fontFamily: 'Circular-Std' }}>Importação automática do servidor</Title>
          <Subtitle>
            {parsedDate == null ? 'Nenhum exame foi importado ainda.'
              : `Última importação realizada com sucesso em ${parsedDate}.`}
          </Subtitle>
        </TitleArea>
      </TitleContainer>
      <ButtonContainer>
        <Button
          onClick={() => !loading && setShowDatePickerModal(true)}
          style={{ width: '335px', cursor: loading ? 'not-allowed' : 'pointer' }}
        >
          {loading ? (
            <Loading
              color="white"
              height={20}
              width={20}
            />
          ) : (
            <span className="material-symbols-outlined">
              autorenew
            </span>
          )}
          Buscar por novos exames no servidor
        </Button>
      </ButtonContainer>
      <TableContainer>
        <LabExamsTable />
      </TableContainer>
      {showDatePickerModal && (
        <SearchExamsModal
          isOpen={showDatePickerModal}
          setClose={() => setShowDatePickerModal(false)}
          onSearch={handleSearch}
        />
      )}
      {showSearchExamsModal && (
      <NotificationModal
        isOpen={showSearchExamsModal}
        setClose={() => setShowSearchExamsModal(false)}
        title="Resultados da busca"
        subtitle={`Importação concluida com sucesso. ${difference === 0 ? 'Nenhum exame novo foi encontrado' : `Foram encontrados ${difference} novo(s) exame(s).`}`}
        primaryButtonLabel="Ok, entendi"
        onClickPrimary={() => setShowSearchExamsModal(false)}
      />
      )}
    </Container>
  )
}

ExamsImport.propTypes = {
  lastImportedAt: PropTypes.string,
  getLastImportedAt: PropTypes.func.isRequired,
  listImportedExams: PropTypes.func.isRequired,
  searchNewExams: PropTypes.func.isRequired,
}

ExamsImport.defaultProps = {
  lastImportedAt: null,
}

const mapStateToProps = ({ exam }) => ({
  lastImportedAt: exam.lastImportedAt,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getLastImportedAt: getLastImportedAtAction,
  listImportedExams: listImportedExamsAction,
  searchNewExams: searchNewExamsAction,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ExamsImport)
